import { Color } from "../defines/colors"
import {
  Direction,
  EnemyType,
  EntryLocation,
  ItemType,
  MapID,
  MapType,
  PopupID,
} from "../defines/enums"
import { MapData } from "../defines/types"
import { Dims, MapDefaults } from "../defines/values"

function standardRandomOptions() {
  const width: [number, number] = [12, 15]
  const height: [number, number] = [9, 12]

  return {
    roomWidthRange: width,
    roomHeightRange: height,
    maxFillPercentage: 0.9,
    timeLimit: 3000.0,
  }
}

// Account for these offsets!
// HOFFSET = 1
// VOFFSET = 5
const maps: { [key: string]: MapData } = {
  portals: {
    type: MapType.STATIC,
    music: { source: "14 Portals.ogg", title: "Portals [needs title]" },
    width: 80,
    height: 40,
    viewportWidth: 80,
    viewportHeight: 40,
    enableFogOfWar: false,
    items: [
      {
        row: 7,
        column: 26,
        keyTarget: MapID.January,
        type: ItemType.KEY,
      },
      // {
      //   type: ItemType.HINT_INFO,
      //   textContents: "Instructions linked below.",
      //   row: 13,
      //   column: 40,
      // },
      {
        type: ItemType.HINT_INFO,
        textContents: "Find and use the key to January.",
        row: 8,
        column: 27,
      },
    ],
    rooms: [
      { x: 20, y: 7, width: 37, height: 17 },
      {
        x: 23,
        y: 1,
        width: 7,
        height: 5,
        name: "Jan",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 35,
        y: 1,
        width: 7,
        height: 5,
        name: "Feb",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 47,
        y: 1,
        width: 7,
        height: 5,
        name: "Mar",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 60,
        y: 7,
        width: 7,
        height: 5,
        name: "Apr",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 60,
        y: 13,
        width: 7,
        height: 5,
        name: "May",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 60,
        y: 19,
        width: 7,
        height: 5,
        name: "Jun",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 47,
        y: 25,
        width: 7,
        height: 5,
        name: "Jul",
        entry: EntryLocation.BOTTOM_CENTER,
      },
      {
        x: 35,
        y: 25,
        width: 7,
        height: 5,
        name: "Aug",
        entry: EntryLocation.BOTTOM_CENTER,
      },
      {
        x: 23,
        y: 25,
        width: 7,
        height: 5,
        name: "Sep",
        entry: EntryLocation.BOTTOM_CENTER,
      },
      {
        x: 10,
        y: 19,
        width: 7,
        height: 5,
        name: "Oct",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 10,
        y: 13,
        width: 7,
        height: 5,
        name: "Nov",
        entry: EntryLocation.TOP_CENTER,
      },
      {
        x: 10,
        y: 7,
        width: 7,
        height: 5,
        name: "Dec",
        entry: EntryLocation.TOP_CENTER,
      },
    ],
    corridors: [
      {
        room: 1,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.BOTTOM_CENTER,
        direction: Direction.DOWN,
      },
      {
        room: 2,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.BOTTOM_CENTER,
        direction: Direction.DOWN,
      },
      {
        room: 3,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.BOTTOM_CENTER,
        direction: Direction.DOWN,
      },
      {
        room: 4,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.LEFT_CENTER,
        direction: Direction.LEFT,
      },
      {
        room: 5,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.LEFT_CENTER,
        direction: Direction.LEFT,
      },
      {
        room: 6,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.LEFT_CENTER,
        direction: Direction.LEFT,
      },
      {
        room: 7,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.TOP_CENTER,
        direction: Direction.UP,
      },
      {
        room: 8,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.TOP_CENTER,
        direction: Direction.UP,
      },
      {
        room: 9,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.TOP_CENTER,
        direction: Direction.UP,
      },
      {
        room: 10,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.RIGHT_CENTER,
        direction: Direction.RIGHT,
      },
      {
        room: 11,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.RIGHT_CENTER,
        direction: Direction.RIGHT,
      },
      {
        room: 12,
        length: MapDefaults.CORRIDOR_LENGTH,
        entry: EntryLocation.RIGHT_CENTER,
        direction: Direction.RIGHT,
      },
    ],
    doors: [
      {
        room: 1,
        location: EntryLocation.BOTTOM_CENTER,
        target: MapID.January,
        unlockDate: "2025-01-01",
      },
      {
        room: 2,
        location: EntryLocation.BOTTOM_CENTER,
        target: MapID.February,
        unlockDate: "2025-02-01",
      },
      {
        room: 3,
        location: EntryLocation.BOTTOM_CENTER,
        target: MapID.March,
        unlockDate: "2025-03-01",
      },
      {
        room: 4,
        location: EntryLocation.LEFT_CENTER,
        target: MapID.April,
        unlockDate: "2025-04-01",
      },
      {
        room: 5,
        location: EntryLocation.LEFT_CENTER,
        target: MapID.May,
        unlockDate: "2025-05-01",
      },
      {
        room: 6,
        location: EntryLocation.LEFT_CENTER,
        target: MapID.June,
        unlockDate: "2025-06-01",
      },
      {
        room: 7,
        location: EntryLocation.TOP_CENTER,
        target: MapID.July,
        unlockDate: "2025-07-01",
      },
      {
        room: 8,
        location: EntryLocation.TOP_CENTER,
        target: MapID.August,
        unlockDate: "2025-08-01",
      },
      {
        room: 9,
        location: EntryLocation.TOP_CENTER,
        target: MapID.September,
        unlockDate: "2025-09-01",
      },
      {
        room: 10,
        location: EntryLocation.RIGHT_CENTER,
        target: MapID.October,
        unlockDate: "2025-10-01",
      },
      {
        room: 11,
        location: EntryLocation.RIGHT_CENTER,
        target: MapID.November,
        unlockDate: "2025-11-01",
      },
      {
        room: 12,
        location: EntryLocation.RIGHT_CENTER,
        target: MapID.December,
        unlockDate: "2025-12-01",
      },
    ],
    portals: [
      { room: 0, target: MapID.Portals },
      { room: 1, target: MapID.January },
      { room: 2, target: MapID.February },
      { room: 3, target: MapID.March },
      { room: 4, target: MapID.April },
      { room: 5, target: MapID.May },
      { room: 6, target: MapID.June },
      { room: 7, target: MapID.July },
      { room: 8, target: MapID.August },
      { room: 9, target: MapID.September },
      { room: 10, target: MapID.October },
      { room: 11, target: MapID.November },
      { room: 12, target: MapID.December },
    ],
    popups: [
      {
        row: 12,
        column: 29,
        target: PopupID.TAPESTRY,
        type: ItemType.ENTRANCE,
      },
      {
        row: 14,
        column: 29,
        target: PopupID.ARCHIVE,
        type: ItemType.ENTRANCE,
      },
      {
        row: 16,
        column: 29,
        target: PopupID.BESTIARY,
        type: ItemType.ENTRANCE,
      },
      {
        row: 18,
        column: 29,
        target: PopupID.WARDROBE,
        type: ItemType.ENTRANCE,
      },
      {
        row: 12,
        column: 48,
        target: PopupID.ARSENAL,
        type: ItemType.ENTRANCE,
      },
      {
        row: 14,
        column: 48,
        target: PopupID.GIZMOS,
        type: ItemType.ENTRANCE,
      },
      {
        row: 16,
        column: 48,
        target: PopupID.COMMON_FINDS,
        type: ItemType.ENTRANCE,
      },
      {
        row: 18,
        column: 48,
        target: PopupID.MYTHIC_FINDS,
        type: ItemType.ENTRANCE,
      },
    ],
    player: 0,
  },
  playground: {
    type: MapType.STATIC,
    width: 80,
    height: 40,
    viewportWidth: 80,
    viewportHeight: 40,
    enableFogOfWar: false,
    rooms: [{ x: 20, y: 7, width: 37, height: 17 }],
    portals: [{ room: 0, target: MapID.Playground }],
    enemies: [
      // { type: EnemyType.RIFT_ESSENCE, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.RIFT_PIGMENT, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.RIFT_BOTH, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.VOID_ESSENCE, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.VOID_PIGMENT, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.VOID_BOTH, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.BLADE_ESSENCE, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.BLADE_PIGMENT, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.BLADE_BOTH, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.SPECTRE_ESSENCE, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.SPECTRE_PIGMENT, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.SPECTRE_BOTH, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.REAVER_ESSENCE, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.REAVER_PIGMENT, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.REAVER_BOTH, min: 1, max: 1, mapMax: 1 },
      // { type: EnemyType.DEVOURER, min: 1, max: 1, mapMax: 1 },
    ],
    items: [{ type: ItemType.OPTIC_RED }],
    player: 0,
  },
  january: {
    type: MapType.DYNAMIC,
    music: { source: "02 January.ogg", title: "January [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    palette: {
      red: { range: { min: 3, max: 4 }, mapMax: 40 },
      green: { range: { min: 0, max: 1 }, mapMax: 10 },
    },
    mazeRooms: [
      {
        colors: [
          ["red", 5],
          ["green", 1],
        ],
      },
    ],
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD1 },
      { type: ItemType.EQUIPMENT_FEET1 },
      { type: ItemType.EQUIPMENT_WEAPON1 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 5 },
    items: [
      {
        keyTarget: MapID.February,
        type: ItemType.KEY,
      },
      { type: ItemType.OPTIC_RED },
      {
        type: ItemType.HINT_INFO,
        textContents: "Find an optic; cycle optics with [SPACE] key.",
        dropNearPlayer: true,
      },
      {
        type: ItemType.HINT_WARNING,
        textContents:
          "%c{#fff}%b{#000}Beware the devourers (" +
          `%c{#f00}%b{${Color.DANGER_TILE}} ` +
          "%c{#fff}%b{#000}) in the maze",
        dropNearPlayer: true,
      },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [{ type: EnemyType.RIFT_ESSENCE, min: 0, max: 2, mapMax: 8 }],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  february: {
    type: MapType.DYNAMIC,
    music: { source: "03 February.ogg", title: "February [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      red: { range: { min: 1, max: 2 }, mapMax: 20 },
      green: { range: { min: 3, max: 4 }, mapMax: 40 },
      blue: { range: { min: 0, max: 1 }, mapMax: 10 },
    },
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 4],
          ["blue", 1],
        ],
      },
    ],
    equipment: [
      { type: ItemType.EQUIPMENT_TORSO1 },
      { type: ItemType.EQUIPMENT_FEET2 },
      { type: ItemType.EQUIPMENT_WEAPON2 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 5 },
    items: [
      {
        type: ItemType.KEY,
        keyTarget: MapID.March,
      },
      { type: ItemType.OPTIC_GREEN },
      {
        type: ItemType.HINT_WARNING,
        textContents: "Some enemies drain essence. Others drain pigment.",
        dropNearPlayer: true,
      },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 2, mapMax: 8 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  march: {
    type: MapType.DYNAMIC,
    music: { source: "04 March.ogg", title: "March [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      green: { range: { min: 1, max: 2 }, mapMax: 20 },
      blue: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 4],
        ],
      },
    ],
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD2 },
      { type: ItemType.EQUIPMENT_FEET3 },
      { type: ItemType.EQUIPMENT_WEAPON3 },
      { type: ItemType.EQUIPMENT_GIZMO1 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 6 },
    items: [
      {
        type: ItemType.KEY,
        keyTarget: MapID.April,
      },
      { type: ItemType.OPTIC_BLUE },
      {
        type: ItemType.HINT_WARNING,
        textContents: "Some enemies drain essence+pigment.",
        dropNearPlayer: true,
      },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 2, mapMax: 8 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  april: {
    type: MapType.DYNAMIC,
    music: { source: "05 April.ogg", title: "April [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 2],
          ["green", 2],
          ["blue", 2],
          ["yellow", 1],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      red: { range: { min: 1, max: 2 }, mapMax: 20 },
      blue: { range: { min: 1, max: 2 }, mapMax: 20 },
      yellow: { range: { min: 0, max: 1 }, mapMax: 10 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD3 },
      { type: ItemType.EQUIPMENT_TORSO2 },
      { type: ItemType.EQUIPMENT_GIZMO2 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 7 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.May },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_ESSENCE, min: 0, max: 1, mapMax: 6 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  may: {
    type: MapType.DYNAMIC,
    music: { source: "06 May.ogg", title: "May [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 1],
          ["yellow", 7],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      green: { range: { min: 1, max: 2 }, mapMax: 20 },
      yellow: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_TORSO3 },
      { type: ItemType.EQUIPMENT_FEET4 },
      { type: ItemType.EQUIPMENT_WEAPON4 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 8 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.June },
      { type: ItemType.OPTIC_YELLOW },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_PIGMENT, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 1, mapMax: 6 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  june: {
    type: MapType.DYNAMIC,
    music: { source: "07 June.ogg", title: "June [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 3],
          ["blue", 3],
          ["yellow", 3],
          ["magenta", 1],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      green: { range: { min: 0, max: 1 }, mapMax: 10 },
      blue: { range: { min: 0, max: 1 }, mapMax: 10 },
      yellow: { range: { min: 1, max: 2 }, mapMax: 20 },
      magenta: { range: { min: 0, max: 1 }, mapMax: 10 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD4 },
      { type: ItemType.EQUIPMENT_WEAPON5 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 8 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.July },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 1, mapMax: 6 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  july: {
    type: MapType.DYNAMIC,
    music: { source: "08 July.ogg", title: "July [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 1],
          ["yellow", 1],
          ["magenta", 6],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      red: { range: { min: 0, max: 1 }, mapMax: 10 },
      blue: { range: { min: 0, max: 1 }, mapMax: 10 },
      magenta: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD5 },
      { type: ItemType.EQUIPMENT_TORSO4 },
      { type: ItemType.EQUIPMENT_FEET5 },
      { type: ItemType.EQUIPMENT_GIZMO3 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 9 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.August },
      { type: ItemType.OPTIC_MAGENTA },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.SPECTRE_ESSENCE, min: 0, max: 1, mapMax: 4 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  august: {
    type: MapType.DYNAMIC,
    music: { source: "09 August.ogg", title: "August [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 2],
          ["yellow", 3],
          ["magenta", 3],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      yellow: { range: { min: 0, max: 1 }, mapMax: 10 },
      magenta: { range: { min: 1, max: 2 }, mapMax: 20 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD6 },
      { type: ItemType.EQUIPMENT_TORSO5 },
      { type: ItemType.EQUIPMENT_WEAPON6 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 9 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.September },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_ESSENCE, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.SPECTRE_ESSENCE, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.SPECTRE_PIGMENT, min: 0, max: 1, mapMax: 4 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  september: {
    type: MapType.DYNAMIC,
    music: { source: "10 September.ogg", title: "September [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 2],
          ["green", 2],
          ["blue", 2],
          ["yellow", 2],
          ["magenta", 2],
          ["cyan", 2],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      green: { range: { min: 0, max: 1 }, mapMax: 10 },
      yellow: { range: { min: 0, max: 1 }, mapMax: 10 },
      magenta: { range: { min: 0, max: 1 }, mapMax: 10 },
      cyan: { range: { min: 0, max: 1 }, mapMax: 10 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_TORSO6 },
      { type: ItemType.EQUIPMENT_FEET6 },
      { type: ItemType.EQUIPMENT_GIZMO4 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 8 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.October },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_PIGMENT, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.VOID_PIGMENT, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 1, mapMax: 6 },
      { type: EnemyType.SPECTRE_ESSENCE, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.SPECTRE_PIGMENT, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.SPECTRE_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.REAVER_ESSENCE, min: 0, max: 1, mapMax: 4 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  october: {
    type: MapType.DYNAMIC,
    music: { source: "11 October.ogg", title: "October [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 1],
          ["yellow", 1],
          ["magenta", 4],
          ["cyan", 12],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      green: { range: { min: 0, max: 1 }, mapMax: 10 },
      blue: { range: { min: 0, max: 1 }, mapMax: 10 },
      cyan: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD7 },
      { type: ItemType.EQUIPMENT_FEET7 },
      { type: ItemType.EQUIPMENT_WEAPON7 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 8 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.November },
      { type: ItemType.OPTIC_CYAN },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.BLADE_ESSENCE, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.SPECTRE_ESSENCE, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.SPECTRE_PIGMENT, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.SPECTRE_BOTH, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.REAVER_ESSENCE, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.REAVER_PIGMENT, min: 0, max: 1, mapMax: 4 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  november: {
    type: MapType.DYNAMIC,
    music: { source: "12 November.ogg", title: "November [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 1],
          ["yellow", 1],
          ["magenta", 2],
          ["cyan", 4],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      red: { range: { min: 3, max: 4 }, mapMax: 40 },
      green: { range: { min: 3, max: 4 }, mapMax: 40 },
      blue: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_TORSO7 },
      { type: ItemType.EQUIPMENT_GIZMO5 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 7 },
    items: [
      { type: ItemType.KEY, keyTarget: MapID.December },
      { type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } },
    ],
    enemies: [
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.BLADE_PIGMENT, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 2, mapMax: 8 },
      { type: EnemyType.SPECTRE_ESSENCE, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.SPECTRE_PIGMENT, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.SPECTRE_BOTH, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.REAVER_ESSENCE, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.REAVER_PIGMENT, min: 0, max: 2, mapMax: 6 },
      { type: EnemyType.REAVER_BOTH, min: 0, max: 1, mapMax: 4 },
    ],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
  december: {
    type: MapType.DYNAMIC,
    music: { source: "13 December.ogg", title: "December [needs title]" },
    width: Dims.DEFAULT_DYNAMIC_MAP_WIDTH,
    height: Dims.DEFAULT_DYNAMIC_MAP_HEIGHT,
    enableFogOfWar: true,
    randomOptions: standardRandomOptions(),
    mazeRooms: [
      {
        colors: [
          ["red", 1],
          ["green", 1],
          ["blue", 1],
          ["yellow", 1],
          ["magenta", 1],
          ["cyan", 1],
        ],
      },
    ],
    viewportWidth: Dims.MAX_VIEWPORT_WIDTH,
    viewportHeight: Dims.MAX_VIEWPORT_HEIGHT,
    palette: {
      yellow: { range: { min: 3, max: 4 }, mapMax: 40 },
      magenta: { range: { min: 3, max: 4 }, mapMax: 40 },
      cyan: { range: { min: 3, max: 4 }, mapMax: 40 },
    },
    equipment: [
      { type: ItemType.EQUIPMENT_HEAD8 },
      { type: ItemType.EQUIPMENT_TORSO8 },
      { type: ItemType.EQUIPMENT_FEET8 },
    ],
    binder: { minMap: 1, maxMap: 1, maxEver: 6 },
    enemies: [
      { type: EnemyType.RIFT_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.VOID_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.BLADE_BOTH, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.SPECTRE_PIGMENT, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.SPECTRE_BOTH, min: 0, max: 1, mapMax: 4 },
      { type: EnemyType.REAVER_ESSENCE, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.REAVER_PIGMENT, min: 0, max: 1, mapMax: 2 },
      { type: EnemyType.REAVER_BOTH, min: 0, max: 2, mapMax: 6 },
    ],
    items: [{ type: ItemType.ELIXIR, minMax: { min: 1, max: 2 } }],
    portals: [{ room: 0, target: MapID.Portals }],
    player: 0,
  },
}

export { maps }
